var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldDocumentCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.68 2.65v3.49c0 1.46 1.24 2.67 2.75 2.67.95.01 2.27.01 3.4.01.57 0 .87-.67.47-1.07-1.44-1.45-4.02-4.06-5.5-5.54-.41-.41-1.12-.13-1.12.44zM14.76 19.262c-2.35.17-2.35 3.57 0 3.74h5.56c.67 0 1.33-.25 1.82-.7 1.65-1.44.77-4.32-1.4-4.59-.78-4.69-7.56-2.91-5.96 1.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 14.44c0 .3-.44.44-.66.23-.48-.47-1.07-.83-1.75-1.04-1.68-.52-3.63-.01-4.84 1.27-.81.84-1.22 1.91-1.21 3.07 0 .19-.09.36-.24.47-.8.61-1.3 1.57-1.3 2.68 0 .08 0 .16.01.24.02.32-.21.63-.54.63h-2.9c-3.08 0-5.57-2-5.57-5.57V7.57C2.5 4 4.99 2 8.07 2h4.24c.55 0 1 .45 1 1v2.89c0 2.38 1.92 4.3 4.3 4.3h2.89c.55 0 1 .45 1 1v3.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldDocumentCloud);
export default __webpack_public_path__ + "static/media/vuesax-bold-document-cloud.f6f377c0da9980285f7a9744cf7c1d14.svg";
export { ForwardRef as ReactComponent };